import { render, staticRenderFns } from "./complaintAcceptance.vue?vue&type=template&id=014bbfdb&scoped=true&"
import script from "./complaintAcceptance.vue?vue&type=script&lang=js&"
export * from "./complaintAcceptance.vue?vue&type=script&lang=js&"
import style0 from "./complaintAcceptance.vue?vue&type=style&index=0&id=014bbfdb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014bbfdb",
  null
  
)

export default component.exports